export default __webpack_public_path__ + "static/media/Pro-17a.5f3965dc.png";